// Recovered compiled webpack factory 33754. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { K: () => n });
  let n = (t, e, i = 10) => {
    let n = "",
      s = Math.max(Math.round(e / i), 2);
    for (let e = 0; e < s; e++) n += Math.round(1e4 * t(e / (s - 1))) / 1e4 + ", ";
    return `linear(${n.substring(0, n.length - 2)})`;
  };
}
